import { State } from '@thepassle/app-tools/state.js';
import { ActiveRecord } from './active_record.js';
import { Settings } from '../models/settings.js';
import { Session } from '../models/session.js';
import { Config } from '../models/config.js';
import { requestPersistedStorage } from './utils.js';
import { query } from 'lit/decorators.js';

let settings = new Settings({ key: 'settings' });
let config = new Config({ key: 'config' });

window.settings = settings;
window.config = config;

class SmartState extends State {
  update(updates) {
    return this.setState((currentState) => {
      const nextState = {
        ...currentState,
        ...updates,
      };

      return nextState;
    });
  }
}

export const appState = new SmartState({
  sessions: new Map(),
  settings,
  config,
});

ActiveRecord.eventTarget.addEventListener('database-changed', async (event) => {

  // Actions are only available when modifying the database
  if(event.actions) {
    requestPersistedStorage();
  }

  let sessionsState;
  let sessions;

  if ([undefined, 'key-val'].includes(event.scope)) {
    settings = await Settings.findOrCreate('settings');
    config = await Config.findOrCreate('config');
  }

  if ([undefined, 'sessions'].includes(event.scope)) {
    let statsBeginsAt = settings.statsBeginsAt;
    sessions = await Session.all({
      index: 'startedAt',
      order: 'desc',
      query: statsBeginsAt ? IDBKeyRange.lowerBound(statsBeginsAt) : undefined,
      limit: 1000,
    });

    const lastSession = await Session.lastSession();

    sessionsState = {
      sessions,
      lastSession,
      sessionsCount: await Session.totalFastingDays(settings.statsBeginsAt),
      actualPlan: await Session.calculateActualPlan(settings.statsBeginsAt)
    };
  }

  appState.update({
    ...sessionsState,
    totalFluxHuman: await Session.totalFluxHuman(settings.statsBeginsAt),
    totalFlux: await Session.totalFlux(settings.statsBeginsAt),
    normalizedFluxOffset: await Session.normalizedFluxOffset(settings.statsBeginsAt),
    fluxHistory: await Session.fluxHistory(settings.statsBeginsAt),
    settings,
    config,
  });

});

requestIdleCallback(() => {
  // Load initial data eg. settings, events, activeEvent
  ActiveRecord.dispatchEvent();
});

// appState.addEventListener('state-changed', (event) => {
//   console.log('**** state-changed ****', event.state);
// });

window.appState = appState;

